import { useContext } from 'react'

import { type CommonServices, CommonServicesContext } from '@lib/services'
import { type BrowserService } from '@lib/services/browser'
import { type ExperimentService } from '@lib/services/experiments'
import { type SessionDataService } from '@lib/services/session-data'
import { type UserService } from '@lib/services/user'

export const useCommonServices = (): CommonServices => {
  return useContext(CommonServicesContext)
}

export const useBrowserService = (): BrowserService => {
  return useCommonServices().browserService
}

export const useUserService = (): UserService => {
  return useCommonServices().userService
}

export const useExperimentService = (): ExperimentService => {
  return useCommonServices().experimentService
}

export const useSessionDataService = (): SessionDataService => {
  return useCommonServices().sessionDataService
}
